import './child-bio.scss';

import { SkeletonImage } from '@sola/ark-core/atoms/skeleton-image/skeleton-image.tsx';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';

export const ChildBioSkeleton = () => {
  return (
    <div className="ChildBio__flex flex">
      <div className="ChildBio__media">
        <div className="xl:pr-comfy-xl rounded-lg">
          <SkeletonImage
            width="100%"
            height="auto"
            style={{
              aspectRatio: '3/4',
            }}
            borderRadius="0.5rem"
          />
        </div>
      </div>
      <div className="ChildBio__content flex flex-col gap-comfy-md">
        <div>
          <Skeleton height="3rem" width="80%" />
        </div>
        <div className="mt-comfy-sm">
          <Skeleton height="2rem" width="40%" borderRadius="9999px" />
        </div>
        <div className="mt-comfy-lg flex flex-col gap-snug-lg">
          <Skeleton height="1.5rem" width="70%" />
          <Skeleton height="1.5rem" width="60%" />
          <Skeleton height="1.5rem" width="65%" />
          <Skeleton height="1.5rem" width="55%" />
        </div>
        <div className="mt-comfy-lg flex flex-col gap-snug-md">
          <Skeleton height="1rem" width="100%" />
          <Skeleton height="1rem" width="100%" />
          <Skeleton height="1rem" width="95%" />
          <Skeleton height="1rem" width="90%" />
        </div>
        <div className="mt-comfy-xl">
          <Skeleton height="3rem" width="60%" borderRadius="0.5rem" />
        </div>
      </div>
    </div>
  );
};
